import TasksRunner from 'components/tasks-runner'
import {waitForEvent} from 'utils/dom'


import {API_TASKS} from 'consts/api'

const __default__ = {
  data() {
    return {
      active: 'tg-data',
    }
  },
  computed: {
    tabs(){
      return [
        {value: 'tg-data', title: 'TgData'},
        {value: 'topics', title: 'Topics'},
        {value: 'fixes', title: 'Fixes'},
        {value: 'export', title: 'Export'},
      ]
    } 
  },
  methods: {
    async runImport(tasks, type) {
      let input = this.$refs.file_input
      
      input.value = null
      input.click()
      await waitForEvent(input, 'change')
      
      if (!input.value) {
        return undefined
      } 

      return await tasks.start(`${API_TASKS}/import?type=${type}`, input.files[0], {fileData: true})
    },
    async runFix(tasks, type) {
      return await tasks.start(`${API_TASKS}/fix?type=${type}`)
    },
    async runClear(tasks, type) {
      return await tasks.start(`${API_TASKS}/clear?type=${type}`)
    },
    async runExport(tasks, type) {
      return await tasks.start(`${API_TASKS}/export?type=${type}`)
    },
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'tasks',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get API_TASKS() { return API_TASKS }, get TasksRunner() { return TasksRunner }, get waitForEvent() { return waitForEvent } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})